import React from "react";
import { nullDatePrefix, getFriendlyDay } from "./Track";
import freightPeopleLogo from "assets/images/freight-people-logo-white2x.png";

/**
 * 
 * consignment is JSON with the following:
 * 
  connoteNumber: "ABC123"
  customerName: "Blah"
  customerReference: "0221177221"
  delivered: "2020-06-11T01:25:45+00:00"
  deliveryAddress: {id: 0, code: null, name: "AAA", line1: "BBB", line2: "", …}
  documents: []
  estimatedDelivery: null
  events: (6) [{…}, {…}, {…}, {…}, {…}, {…}]
  hasPOD: false
  id: 854037
  isOntime: true
  onBoardForDelivery: "2020-06-10T22:35:37+00:00"
  pickedUp: "0001-01-01T00:00:00+00:00"
  pickupAddress: {id: 0, code: null, name: "ABC", line1: "1 ABC Drive", line2: null, …}
  pickupDate: "2020-06-09T00:00:00"
  serviceCode: "AAA"
  serviceName: "ABC"
  specialInstructions: null
  status: "Manifested"
  totalItems: 1
  totalVolume: 0.0349
  totalWeight: 0.11
  transportUnits: [{…}]
 */

export const Header = ({ consignment }) => {
    var title =
        !consignment.delivered || consignment.delivered.startsWith(nullDatePrefix)
            ? "No tracking available"
            : "Delivered";
    var description = null;

    if (consignment.events && consignment.events.length > 0) {
        title = consignment.events[0].milestone;

        if (title === "Delivered") {
            description = `Consignment Delivered ${getFriendlyDay(consignment.events[0].eventTime)}`;
        } else if (consignment.estimatedDelivery) {
            description = `Estimated date of delivery ${consignment.estimatedDelivery}`;
        }
    }

    return (
        <div className="d-md-flex mb-5">
            <div className="mb-3 mb-md-0 green-bar-wrap mr-auto">
                <h1 id="status" className="status mb-2 text-white font-weight-bold">
                    {title}
                </h1>
                <p id="consignment-status-details" className="text-white mb-0">
                    {description}
                </p>
            </div>
            <div>
                <img
                    src={freightPeopleLogo}
                    alt=""
                    className="image-3 img-fluid"
                    style={{
                        maxWidth: "225px",
                    }}
                />
            </div>
        </div>
    );
};
